module.exports = {"340181001":"中庙街道","340181002":"亚父街道","340181003":"卧牛山街道","340181004":"凤凰山街道","340181005":"天河街道","340181006":"半汤街道","340181100":"栏杆集镇","340181101":"苏湾镇","340181102":"柘皋镇","340181103":"银屏镇","340181104":"夏阁镇","340181105":"中垾镇","340181106":"散兵镇","340181107":"烔炀镇","340181108":"黄麓镇","340181109":"槐林镇","340181110":"坝镇镇","340181200":"庙岗乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/340181.json
// module id = 963
// module chunks = 0